export const findFolderById = (foldersObj, folderId) => {
    for (const id in foldersObj) {
        if (foldersObj[id].id === folderId) return foldersObj[id];
        const foundInSub = findFolderById(foldersObj[id].subfolders, folderId);
        if (foundInSub) return foundInSub;
    }
    return null;
};

export const updateFolderById = (foldersObj, folderId, updateFn) => {
    const newFolders = { ...foldersObj };
    for (const id in newFolders) {
        if (newFolders[id].id === folderId) {
            newFolders[id] = updateFn(newFolders[id]);
            return newFolders;
        }
        const updatedSubfolders = updateFolderById(newFolders[id].subfolders, folderId, updateFn);
        if (updatedSubfolders !== newFolders[id].subfolders) {
            newFolders[id] = { ...newFolders[id], subfolders: updatedSubfolders };
            return newFolders;
        }
    }
    return foldersObj;
};

export const deleteFolderById = (currentFolders, idToDelete) => {
    const newFolders = { ...currentFolders };
    if (newFolders[idToDelete]) {
        delete newFolders[idToDelete];
        return newFolders;
    }
    for (const id in newFolders) {
        const updatedSubfolders = deleteFolderById(newFolders[id].subfolders, idToDelete);
        if (updatedSubfolders !== newFolders[id].subfolders) {
            newFolders[id] = { ...newFolders[id], subfolders: updatedSubfolders };
            return newFolders;
        }
    }
    return currentFolders;
};

export const getAllFoldersFlat = (foldersObj) => {
    let flatList = [];
    for (const id in foldersObj) {
        flatList.push(foldersObj[id]);
        flatList = flatList.concat(getAllFoldersFlat(foldersObj[id].subfolders));
    }
    return flatList;
};

export const normalizeCardText = (value) => {
  if (value === null || value === undefined) return '';
  if (typeof value === 'string') return value.trim().replace(/\s+/g, ' ').toLowerCase();
  try {
    return JSON.stringify(value).trim().replace(/\s+/g, ' ').toLowerCase();
  } catch {
    return String(value).trim().replace(/\s+/g, ' ').toLowerCase();
  }
};

export const getCardKey = (question, answer) =>
  `${normalizeCardText(question)}|${normalizeCardText(answer)}`;

export const getCardKeyFromCard = (card) => getCardKey(card?.question, card?.answer);

export const buildCardKeySet = (cards = []) => new Set((cards || []).map(getCardKeyFromCard));

export const partitionUniqueCards = (cards = [], keySet = new Set()) => {
  const unique = [];
  let duplicates = 0;
  for (const c of cards || []) {
    const key = getCardKeyFromCard(c);
    if (keySet.has(key)) {
      duplicates += 1;
      continue;
    }
    keySet.add(key);
    unique.push(c);
  }
  return { unique, duplicates, keySet };
};

